(function () {
  "use strict";

  if (window.__zeusPonchoCollectionBooted) return;
  window.__zeusPonchoCollectionBooted = true;

  var globalInit = {
    gallery: false,
    seo: false,
    lightboxFrames: false,
    lightboxLifestyle: false,
    specsDelegation: false,
  };

  var rootCleanups = new WeakMap();
  var lightboxController = null;

  function trackCleanup(root, fn) {
    var list = rootCleanups.get(root) || [];
    list.push(fn);
    rootCleanups.set(root, list);
  }

  function cleanupRoot(root) {
    var list = rootCleanups.get(root);
    if (!list) return;
    list.forEach(function (fn) {
      fn();
    });
    rootCleanups.delete(root);
  }

  function formatMoney(cents) {
    var format =
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      "{{amount}}";
    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace(".", ",");
    var amountNoDecimals = String(Math.round(cents / 100));

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function cartUrl(path) {
    var root = window.Shopify?.routes?.root || "/";
    return root + path;
  }

  function cartAddUrl() {
    if (window.Shopify?.routes?.root) {
      return window.Shopify.routes.root + "cart/add.js";
    }
    if (window.routes?.cart_add_url) {
      return window.routes.cart_add_url + ".js";
    }
    return cartUrl("cart/add.js");
  }

  function cartJsUrl() {
    return cartUrl("cart.js");
  }

  function cartUpdateUrl() {
    return cartUrl("cart/update.js");
  }

  function purchaseOptionLabel(option) {
    var label = option.dataset.color || "";
    if (option.dataset.size) {
      label = label ? label + " — " + option.dataset.size : option.dataset.size;
    }
    return label;
  }

  function openCartDrawer() {
    var drawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }
    if (drawer && typeof drawer.show === "function") {
      drawer.show();
      return;
    }
    var ariaTrigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (ariaTrigger) {
      ariaTrigger.click();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || "/cart";
  }

  function cartHasDiscountCode(cart, code) {
    if (!code) return true;
    var target = code.toLowerCase();
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var app = apps[i];
      if ((app.title && app.title.toLowerCase() === target) || (app.code && app.code.toLowerCase() === target)) {
        return true;
      }
    }
    return false;
  }

  function addVariantsToCart(variantIds, onDone, onError, options) {
    options = options || {};
    var openDrawer = options.openDrawer !== false;
    var items = variantIds.map(function (id) {
      return { id: parseInt(id, 10), quantity: 1 };
    });

    fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch(cartJsUrl(), { headers: { Accept: "application/json" } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:items-changed", { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:add", { detail: { cart: cart } }));
        if (openDrawer) openCartDrawer();
        if (onDone) onDone(cart);
      })
      .catch(function (err) {
        console.error("[zeus-poncho-collection] cart add failed", err);
        if (onError) onError(err);
      });
  }

  function initFilters(root) {
    var filterButtons = root.querySelectorAll("[data-poncho-filter]");
    var cards = root.querySelectorAll("[data-poncho-size-group]");
    var visibleCount = root.querySelector("[data-poncho-visible-count]");
    if (!filterButtons.length) return;

    function setFilter(filter) {
      var count = 0;
      filterButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.ponchoFilter === filter));
      });
      cards.forEach(function (card) {
        var shouldShow = filter === "all" || card.dataset.ponchoSizeGroup === filter;
        card.hidden = !shouldShow;
        if (shouldShow) count += 1;
      });
      if (visibleCount) visibleCount.textContent = String(count);
    }

    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setFilter(button.dataset.ponchoFilter);
      });
    });
    setFilter("all");
  }

  function initPackBuilder(root) {
    var packRoot = root.querySelector("[data-poncho-pack]");
    if (!packRoot) return;

    var unitPrice = parseInt(packRoot.dataset.unitPriceCents, 10) || 5995;
    var packPrices = {
      2: parseInt(packRoot.dataset.duoPriceCents, 10) || 10000,
      3: parseInt(packRoot.dataset.trioPriceCents, 10) || 13000,
    };
    var tierButtons = packRoot.querySelectorAll("[data-poncho-pack-tier]");
    var slotsEl = packRoot.querySelector("[data-poncho-pack-slots]");
    var slotButtons = packRoot.querySelectorAll("[data-poncho-pack-slot]");
    var swatches = packRoot.querySelectorAll("[data-poncho-pack-swatch]");
    var summaryTitle = packRoot.querySelector("[data-poncho-pack-summary-title]");
    var compareEl = packRoot.querySelector("[data-poncho-pack-compare]");
    var saveEl = packRoot.querySelector("[data-poncho-pack-save]");
    var totalEl = packRoot.querySelector("[data-poncho-pack-total]");
    var hintEl = packRoot.querySelector("[data-poncho-pack-hint]");
    var ctaEl = packRoot.querySelector("[data-poncho-pack-cta]");
    var feedbackEl = packRoot.querySelector("[data-poncho-pack-feedback]");
    var fallbackDiscountCode = packRoot.dataset.packDiscountCode || "";
    var packNoCodeMessage = packRoot.dataset.packNoCode || "";
    var duoDiscountCode = packRoot.dataset.duoDiscountCode || fallbackDiscountCode;
    var trioDiscountCode = packRoot.dataset.trioDiscountCode || fallbackDiscountCode;

    function packDiscountCodeForSize() {
      return packSize === 2 ? duoDiscountCode : trioDiscountCode;
    }

    var packSize = 2;
    var activeSlot = 0;
    var selections = [null, null, null];

    function renderSlot(index) {
      var slot = slotButtons[index];
      var pick = selections[index];
      var thumb = slot.querySelector("[data-poncho-pack-thumb]");
      var name = slot.querySelector("[data-poncho-pack-name]");
      var placeholder = slot.querySelector("[data-poncho-pack-placeholder]");
      var filled = Boolean(pick);
      slot.classList.toggle("is-filled", filled);
      if (filled) {
        thumb.hidden = false;
        name.hidden = false;
        placeholder.hidden = true;
        thumb.src = pick.img;
        thumb.alt = pick.color;
        name.textContent = pick.color;
      } else {
        thumb.hidden = true;
        name.hidden = true;
        placeholder.hidden = false;
        thumb.removeAttribute("src");
        thumb.alt = "";
        name.textContent = "";
      }
    }

    function setActiveSlot(index) {
      activeSlot = index;
      slotButtons.forEach(function (slot) {
        slot.classList.toggle("is-active", Number(slot.dataset.ponchoPackSlot) === index);
      });
    }

    function updateSummary() {
      var price = packPrices[packSize];
      var compare = unitPrice * packSize;
      var save = compare - price;
      var filled = selections.slice(0, packSize).filter(Boolean).length;
      var ready = filled === packSize;

      if (summaryTitle) {
        summaryTitle.textContent =
          packSize === 2 ? packRoot.dataset.duoLabel || "Pack Duo" : packRoot.dataset.trioLabel || "Pack Trio";
      }
      if (compareEl) compareEl.textContent = formatMoney(compare);
      if (saveEl) saveEl.textContent = formatMoney(save);
      if (totalEl) totalEl.textContent = formatMoney(price);
      if (ctaEl) {
        ctaEl.disabled = !ready;
        ctaEl.textContent = ready
          ? packSize === 2
            ? packRoot.dataset.duoCtaReady || ctaEl.dataset.defaultReadyDuo || "Ajouter le Duo"
            : packRoot.dataset.trioCtaReady || ctaEl.dataset.defaultReadyTrio || "Ajouter le Trio"
          : packRoot.dataset.ctaIdle || "Composer mon pack";
      }

      if (hintEl) {
        if (ready) {
          hintEl.textContent = selections
            .slice(0, packSize)
            .map(function (item) {
              return item.color;
            })
            .join(" + ");
        } else if (filled === 0) {
          hintEl.textContent = (packRoot.dataset.hintEmpty || "Choisis [count] coloris.").replace(
            "[count]",
            String(packSize),
          );
        } else {
          hintEl.textContent = (packRoot.dataset.hintRemaining || "Encore [count] coloris.").replace(
            "[count]",
            String(packSize - filled),
          );
        }
      }
      if (feedbackEl) feedbackEl.textContent = "";
    }

    function syncSwatchPressed() {
      swatches.forEach(function (item) {
        var used = selections.slice(0, packSize).some(function (pick) {
          return pick && pick.variantId === item.dataset.variantId;
        });
        item.setAttribute("aria-pressed", String(used));
      });
    }

    function setPackSize(size) {
      packSize = size;
      if (slotsEl) slotsEl.dataset.size = String(size);
      tierButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(Number(button.dataset.ponchoPackTier) === size));
      });
      if (activeSlot >= size) setActiveSlot(0);
      if (size === 2) {
        selections[2] = null;
        renderSlot(2);
      }
      syncSwatchPressed();
      updateSummary();
    }

    tierButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setPackSize(Number(button.dataset.ponchoPackTier));
      });
    });

    slotButtons.forEach(function (slot) {
      slot.addEventListener("click", function () {
        var index = Number(slot.dataset.ponchoPackSlot);
        if (index >= packSize) return;
        setActiveSlot(index);
      });
    });

    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        var pick = {
          color: swatch.dataset.color,
          variantId: swatch.dataset.variantId,
          img: swatch.dataset.img,
        };
        selections[activeSlot] = pick;
        renderSlot(activeSlot);
        syncSwatchPressed();
        var nextEmpty = selections.findIndex(function (item, index) {
          return index < packSize && !item;
        });
        if (nextEmpty !== -1) setActiveSlot(nextEmpty);
        updateSummary();
      });
    });

    if (ctaEl) {
      ctaEl.addEventListener("click", function () {
        if (ctaEl.disabled) return;
        var discountCode = packDiscountCodeForSize();
        if (!discountCode) {
          if (feedbackEl) {
            feedbackEl.textContent =
              packNoCodeMessage ||
              "Remise indisponible : configure le code promo du pack dans le thème pour activer le Duo/Trio.";
          }
          return;
        }
        ctaEl.disabled = true;
        var ids = selections.slice(0, packSize).map(function (item) {
          return item.variantId;
        });
        addVariantsToCart(
          ids,
          function () {
            function closePack() {
              ctaEl.disabled = false;
              var modal = root.querySelector("[data-poncho-pack-modal]");
              if (modal) modal.setAttribute("aria-hidden", "true");
              document.body.style.overflow = "";
            }

            function finishPack(cart) {
              document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
              document.dispatchEvent(new CustomEvent("cart:items-changed", { detail: { cart: cart } }));
              openCartDrawer();
              closePack();
            }

            fetch(cartUpdateUrl(), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                discount: discountCode,
                attributes: { _poncho_pack: packSize === 2 ? "duo" : "trio" },
              }),
            })
              .then(function (res) {
                if (!res.ok) {
                  return res.json().then(function (err) {
                    throw err;
                  });
                }
                return res.json();
              })
              .then(function () {
                return fetch(cartJsUrl(), { headers: { Accept: "application/json" } }).then(function (r) {
                  return r.json();
                });
              })
              .then(function (cart) {
                if (!cartHasDiscountCode(cart, discountCode)) {
                  throw {
                    description: "Les articles sont dans le panier, mais la remise n'a pas pu être appliquée.",
                  };
                }
                finishPack(cart);
              })
              .catch(function (err) {
                ctaEl.disabled = false;
                if (feedbackEl) {
                  feedbackEl.textContent =
                    (err && err.description) ||
                    (err && err.message) ||
                    "Les articles sont dans le panier, mais la remise n'a pas pu être appliquée.";
                }
              });
          },
          function (err) {
            ctaEl.disabled = false;
            if (feedbackEl) {
              feedbackEl.textContent = (err && err.description) || (err && err.message) || "Erreur panier.";
            }
          },
          { openDrawer: !discountCode },
        );
      });
    }

    setPackSize(2);
    setActiveSlot(0);
    updateSummary();
  }

  function initPackModal(root) {
    var packModal = root.querySelector("[data-poncho-pack-modal]");
    if (!packModal) return;
    var packDialog = packModal.querySelector(".zeus-poncho-pack-modal__dialog");
    var packOpeners = root.querySelectorAll("[data-poncho-pack-open]");
    var packClosers = packModal.querySelectorAll("[data-poncho-pack-close]");
    var packLastFocus = null;

    function getPackFocusable() {
      return packDialog
        ? Array.prototype.slice.call(
            packDialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          )
        : [];
    }

    function openPack(trigger) {
      packLastFocus = trigger;
      packModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (packDialog) packDialog.focus();
    }

    function closePack() {
      packModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (packLastFocus) packLastFocus.focus();
    }

    packOpeners.forEach(function (opener) {
      opener.addEventListener("click", function () {
        openPack(opener);
      });
    });
    packClosers.forEach(function (closer) {
      closer.addEventListener("click", closePack);
    });

    function onPackKeydown(event) {
      if (packModal.getAttribute("aria-hidden") === "true") return;
      if (event.key === "Escape") {
        closePack();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = getPackFocusable();
      if (focusable.length < 2) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener("keydown", onPackKeydown);
    trackCleanup(root, function () {
      document.removeEventListener("keydown", onPackKeydown);
    });
  }

  function initCardAddToCart(root) {
    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-poncho-add-to-cart]");
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      if (button.disabled || button.getAttribute("aria-busy") === "true") return;

      var variantId = button.dataset.variantId;
      if (!variantId) return;

      button.setAttribute("aria-busy", "true");
      button.disabled = true;

      addVariantsToCart(
        [variantId],
        function () {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        },
        function () {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        },
      );
    });
  }

  function initPurchaseBar(root) {
    var purchaseBar = root.querySelector("[data-poncho-purchase-bar]");
    if (!purchaseBar || !("IntersectionObserver" in window)) return;

    var purchaseDismiss = root.querySelector("[data-poncho-purchase-dismiss]");
    var purchaseOptions = root.querySelectorAll("[data-poncho-purchase-option]");
    var purchaseSelection = root.querySelector("[data-poncho-purchase-selection]");
    var purchaseCta = root.querySelector("[data-poncho-purchase-cta]");
    var purchasePrice = root.querySelector("[data-poncho-purchase-price]");
    var catalogue = root.querySelector("[data-poncho-catalogue]");
    var observeTarget =
      document.querySelector("footer") || document.querySelector(".shopify-section-group-footer-group");

    purchaseOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        purchaseOptions.forEach(function (item) {
          item.setAttribute("aria-pressed", String(item === option));
        });
        if (purchaseSelection) purchaseSelection.textContent = purchaseOptionLabel(option);
        if (purchaseCta) purchaseCta.href = option.dataset.url;
        if (purchasePrice && option.dataset.priceCents) {
          purchasePrice.textContent = formatMoney(parseInt(option.dataset.priceCents, 10));
        }
      });
    });

    var cataloguePast = false;
    var footerIsVisible = false;
    var dismissed = false;

    function updatePurchaseBar() {
      var shouldShow = cataloguePast && !footerIsVisible && !dismissed;
      purchaseBar.classList.toggle("is-visible", shouldShow);
      purchaseBar.setAttribute("aria-hidden", String(!shouldShow));
      purchaseBar.toggleAttribute("inert", !shouldShow);
    }

    if (purchaseDismiss) {
      purchaseDismiss.addEventListener("click", function () {
        dismissed = true;
        updatePurchaseBar();
      });
    }

    var purchaseObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (catalogue && entry.target === catalogue) {
          cataloguePast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
        if (observeTarget && entry.target === observeTarget) {
          footerIsVisible = entry.isIntersecting;
        }
      });
      updatePurchaseBar();
    });

    if (catalogue) purchaseObserver.observe(catalogue);
    if (observeTarget) purchaseObserver.observe(observeTarget);
  }

  function initSpecsDelegation() {
    if (globalInit.specsDelegation) return;
    globalInit.specsDelegation = true;

    document.addEventListener("click", function (event) {
      var opener = event.target.closest("[data-poncho-specs-open]");
      if (!opener) return;
      var activeRoot = document.querySelector("[data-zeus-poncho-collection]");
      if (!activeRoot) return;
      var specsDrawer = activeRoot.querySelector("[data-poncho-specs-drawer]");
      if (!specsDrawer) return;

      var specsColor = specsDrawer.querySelector("[data-poncho-specs-color]");
      var specsSize = specsDrawer.querySelector("[data-poncho-specs-size]");
      var specsPanel = specsDrawer.querySelector(".zeus-poncho-specs-drawer__panel");
      if (specsColor && opener.dataset.color) specsColor.textContent = opener.dataset.color;
      if (specsSize && opener.dataset.size) specsSize.textContent = opener.dataset.size;
      specsDrawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      specsDrawer.__zeusLastFocus = opener;
      if (specsPanel) specsPanel.focus();
    });
  }

  function initSpecsDrawer(root) {
    var specsDrawer = root.querySelector("[data-poncho-specs-drawer]");
    if (!specsDrawer) return;

    initSpecsDelegation();

    var specsClosers = specsDrawer.querySelectorAll("[data-poncho-specs-close]");

    function closeSpecs() {
      specsDrawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (specsDrawer.__zeusLastFocus) specsDrawer.__zeusLastFocus.focus();
    }

    specsClosers.forEach(function (closer) {
      closer.addEventListener("click", closeSpecs);
    });

    function onSpecsKeydown(event) {
      if (specsDrawer.getAttribute("aria-hidden") === "true") return;
      if (event.key === "Escape") closeSpecs();
    }

    document.addEventListener("keydown", onSpecsKeydown);
    trackCleanup(root, function () {
      document.removeEventListener("keydown", onSpecsKeydown);
    });
  }

  function bindLightboxGalleryTriggers() {
    if (globalInit.lightboxFrames) return;
    globalInit.lightboxFrames = true;

    document.addEventListener("click", function (event) {
      if (!lightboxController) return;
      var frame = event.target.closest("[data-poncho-gallery-frame]");
      if (!frame) return;
      var frameList = document.querySelectorAll("[data-poncho-gallery-frame]");
      var index = Array.prototype.indexOf.call(frameList, frame);
      if (index === -1) return;
      var items = Array.prototype.map.call(frameList, function (f) {
        var image = f.querySelector("img");
        var label = f.querySelector("span");
        var titleEl = document.querySelector("[data-poncho-gallery-title]");
        var title = titleEl ? titleEl.textContent : "";
        return { src: image.src, alt: image.alt, caption: title + " — " + (label ? label.textContent : "") };
      });
      lightboxController.open(items, index, frame);
    });
  }

  function bindLightboxLifestyleTriggers() {
    if (globalInit.lightboxLifestyle) return;
    globalInit.lightboxLifestyle = true;

    document.addEventListener("click", function (event) {
      if (!lightboxController) return;
      var item = event.target.closest("[data-poncho-lifestyle-item]");
      if (!item) return;
      var items = document.querySelectorAll("[data-poncho-lifestyle-item]");
      var index = Array.prototype.indexOf.call(items, item);
      if (index === -1) return;
      var mapped = Array.prototype.map.call(items, function (el) {
        var image = el.querySelector("img");
        return { src: image.src, alt: image.alt, caption: image.alt };
      });
      lightboxController.open(mapped, index, item);
    });
  }

  function initLightbox(root) {
    var lightbox = root.querySelector("[data-poncho-lightbox]");
    if (!lightbox) return;

    var lightboxDialog = lightbox.querySelector(".zeus-poncho-lightbox__dialog");
    var lightboxImage = lightbox.querySelector("[data-poncho-lightbox-image]");
    var lightboxCaption = lightbox.querySelector("[data-poncho-lightbox-caption]");
    var lightboxClose = lightbox.querySelector("[data-poncho-lightbox-close]");
    var lightboxPrev = lightbox.querySelector("[data-poncho-lightbox-prev]");
    var lightboxNext = lightbox.querySelector("[data-poncho-lightbox-next]");
    var lastFocus = null;
    var lightboxItems = [];
    var lightboxIndex = 0;

    function renderLightbox() {
      var item = lightboxItems[lightboxIndex];
      if (!item) return;
      lightboxImage.src = item.src;
      lightboxImage.alt = item.alt;
      lightboxCaption.textContent = item.caption + " · " + (lightboxIndex + 1) + "/" + lightboxItems.length;
      var hasMultiple = lightboxItems.length > 1;
      lightboxPrev.hidden = !hasMultiple;
      lightboxNext.hidden = !hasMultiple;
    }

    function openLightbox(items, index, trigger) {
      lightboxItems = items;
      lightboxIndex = index;
      lastFocus = trigger;
      lightbox.hidden = false;
      document.body.style.overflow = "hidden";
      renderLightbox();
      if (lightboxDialog) lightboxDialog.focus();
    }

    lightboxController = { open: openLightbox, lightbox: lightbox };

    function closeLightbox() {
      lightbox.hidden = true;
      document.body.style.overflow = "";
      if (lastFocus) lastFocus.focus();
    }

    bindLightboxGalleryTriggers();
    bindLightboxLifestyleTriggers();

    if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
    if (lightboxPrev) {
      lightboxPrev.addEventListener("click", function () {
        lightboxIndex = (lightboxIndex - 1 + lightboxItems.length) % lightboxItems.length;
        renderLightbox();
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener("click", function () {
        lightboxIndex = (lightboxIndex + 1) % lightboxItems.length;
        renderLightbox();
      });
    }

    var onLightboxKeydown = function (event) {
      if (lightbox.hidden) return;
      if (event.key === "Escape") closeLightbox();
    };

    document.addEventListener("keydown", onLightboxKeydown);
    trackCleanup(root, function () {
      document.removeEventListener("keydown", onLightboxKeydown);
    });
  }

  function selectGalleryOption(option) {
    var galleryOptions = document.querySelectorAll("[data-poncho-gallery-option]");
    var galleryMain = document.querySelector("[data-poncho-gallery-main]");
    var gallerySecondary = document.querySelector("[data-poncho-gallery-secondary]");
    var galleryDetail = document.querySelector("[data-poncho-gallery-detail]");
    var galleryTitle = document.querySelector("[data-poncho-gallery-title]");
    var gallerySize = document.querySelector("[data-poncho-gallery-size]");
    var galleryCta = document.querySelector("[data-poncho-gallery-cta]");
    var gallerySpecs = document.querySelector(".zeus-poncho-proof [data-poncho-specs-open]");
    var galleryFrames = document.querySelectorAll(".zeus-poncho-proof [data-poncho-gallery-frame]");
    var color = option.dataset.color;
    var size = option.dataset.size;
    var mainSrc = option.dataset.main;
    var secondarySrc = option.dataset.secondary;

    galleryOptions.forEach(function (item) {
      item.setAttribute("aria-pressed", String(item === option));
    });
    if (galleryMain) {
      galleryMain.src = mainSrc;
      galleryMain.alt = option.dataset.mainAlt || galleryMain.alt;
    }
    if (gallerySecondary) {
      gallerySecondary.src = secondarySrc;
      gallerySecondary.alt = option.dataset.secondaryAlt || gallerySecondary.alt;
    }
    if (galleryDetail) {
      galleryDetail.src = mainSrc;
      galleryDetail.alt = option.dataset.detailAlt || galleryDetail.alt;
    }
    if (galleryTitle) galleryTitle.textContent = option.dataset.title || "Poncho Zeus — " + color;
    if (gallerySize) gallerySize.textContent = size;
    if (galleryCta) galleryCta.href = option.dataset.url;
    if (gallerySpecs) {
      gallerySpecs.dataset.color = color;
      gallerySpecs.dataset.size = size;
    }

    galleryFrames.forEach(function (frame) {
      var kind = frame.dataset.ponchoGalleryFrame;
      if (kind === "detail" && option.dataset.detailLabel) {
        frame.setAttribute("aria-label", option.dataset.detailLabel);
      }
      if (kind === "main" && option.dataset.mainLabel) {
        frame.setAttribute("aria-label", option.dataset.mainLabel);
      }
      if (kind === "secondary" && option.dataset.secondaryLabel) {
        frame.setAttribute("aria-label", option.dataset.secondaryLabel);
      }
    });
  }

  function initGallery() {
    if (globalInit.gallery) return;
    if (!document.querySelector("[data-poncho-gallery-option]")) return;
    globalInit.gallery = true;

    document.addEventListener("click", function (event) {
      var option = event.target.closest("[data-poncho-gallery-option]");
      if (!option) return;
      selectGalleryOption(option);
    });
  }

  function initSeoToggle() {
    if (globalInit.seo) return;
    if (!document.querySelector("[data-poncho-seo-toggle]")) return;
    globalInit.seo = true;

    document.addEventListener("click", function (event) {
      var seoToggle = event.target.closest("[data-poncho-seo-toggle]");
      if (!seoToggle) return;
      var seoContent = document.getElementById("poncho-seo-content");
      if (!seoContent) return;
      var less = seoToggle.querySelector(".zeus-poncho-seo__less");
      var more = seoToggle.querySelector(".zeus-poncho-seo__more");
      var expanded = seoToggle.getAttribute("aria-expanded") === "true";
      seoToggle.setAttribute("aria-expanded", String(!expanded));
      seoContent.hidden = expanded;
      if (less && more) {
        less.hidden = expanded;
        more.hidden = !expanded;
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bound === "1") return;
    root.dataset.bound = "1";
    initFilters(root);
    initCardAddToCart(root);
    initPackBuilder(root);
    initPackModal(root);
    initPurchaseBar(root);
    initSpecsDrawer(root);
    initLightbox(root);
  }

  function initAll() {
    document.querySelectorAll("[data-zeus-poncho-collection]").forEach(initRoot);
    initGallery();
    initSeoToggle();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-zeus-poncho-collection]");
    if (root) {
      delete root.dataset.bound;
      initRoot(root);
    }
    initGallery();
    initSeoToggle();
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector("[data-zeus-poncho-collection]");
    if (root) {
      cleanupRoot(root);
      if (lightboxController && root.contains(lightboxController.lightbox)) {
        lightboxController = null;
      }
    }
  });
})();
